import BlShimmerAv from './BlShimmerAv.vue'

BlShimmerAv.install = function(Vue) {
  Vue.component(BlShimmerAv.name, BlShimmerAv)
}

export default BlShimmerAv
